const NAME = "NOTES";

export default NAME;
